import React from "react";
import { NavLink } from "react-router-dom";
import { FileBarChart, Smartphone } from "lucide-react";

/**
 * FormBuilderTabs — small pill switcher between the two Form Builder surfaces:
 *   • /forms          → Clinical Forms library (existing)
 *   • /forms/mobile-app → Mobile App Forms (new admin-controlled content)
 * The `active` prop is a hint; NavLink's active class also handles it.
 */
export default function FormBuilderTabs({ active }) {
  const tabs = [
    { to: "/forms", key: "clinical", label: "Clinical Forms", icon: FileBarChart },
    { to: "/forms/mobile-app", key: "mobile", label: "Mobile App Forms", icon: Smartphone },
  ];
  return (
    <div className="hah-card p-1 inline-flex rounded-lg" data-testid="form-builder-tabs">
      {tabs.map((t) => {
        const Icon = t.icon;
        const isActive = active ? t.key === active : undefined;
        return (
          <NavLink
            key={t.key}
            to={t.to}
            end
            className={({ isActive: navActive }) => {
              const on = isActive ?? navActive;
              return `px-4 py-2 rounded-md text-sm font-semibold flex items-center gap-1.5 transition
                      ${on ? "bg-[#0B7E8C] text-white shadow" : "text-[#374151] hover:bg-[#F3F4F6]"}`;
            }}
            data-testid={`form-builder-tab-${t.key}`}
          >
            <Icon className="w-4 h-4" /> {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
